import React from 'react';

const SettingsContext = React.createContext({
    settings: '',
    setSettings: () => { }
})

export default SettingsContext;